import './SimpleTableV2.css';
export var SimpleTableV2CSS = '_o05dbz0-2-0-1';